<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size:15px; font-weight: bold">manage dailytransactions</small>
      </legend>
      <div></div>
      <div class="dailytransactionsLoader">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <i class="fa fa-spinner fa-spin" style="font-size:24px; color: blue"></i>loading dailtransactions...
      </div>
      <vue-good-table
        :columns="columns"
        :rows="systemDailytransactions"
        :fixed-header="true"
        :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'pettyaccount_id'">
            <span v-if="props.row.pettyaccount_id === 1">
              <button class="btn btn-primary btn-sm btn-flat">
                <i class="fa fa-money"></i> CASH
              </button>
            </span>
            <span v-else-if="props.row.pettyaccount_id === 2">
              <button class="btn btn-success btn-sm">
                <i class="fa fa fa-mobile"></i> MPESA
              </button>
            </span>
          </span>
          <span v-else>{{props.formattedRow[props.column.field]}}</span>
          <span v-if="props.column.field === 'Action'">
            <button type="submit" class="btn btn-primary btn-sm btn-rounded dailytransaction_id" @click="viewTransaction(props.row.id)">
              <i class="fa fa-plus"></i> Petty cash voucher
            </button>
          </span>
        </template>
      </vue-good-table>
    </fieldset>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Payee name",
          field: "payee_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by payee name"
          }
        },
        {
          label: "Payee amount",
          field: "payee_amount",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by payee amount"
          }
        },
        {
          label: "Payee description",
          field: "payee_description",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by payee description"
          }
        },
        {
          label: "Pettycash A/c",
          field: "pettyaccount_id",
          type: "text"
        },
        {
          label: "Submitted by",
          field: "fullname",
          type: "text"
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true
        }
      ]
    };
  },
  created() {
    this.loadTransactions();
  },
  computed: {
    ...mapGetters(["systemDailytransactions", "Dailytransaction"])
  },
  methods: {
    ...mapActions(["loadTransactions", "viewTransaction"])
  }
};
</script>


// WEBPACK FOOTER //
// src/dailytransactions/managedailytransactions.vue